import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

const sanitise = ({eventId, ...rest}) => ({
    eventId: Number(eventId),
    ...rest
});

class EventNotificationStore extends ReduceStore {

    getInitialState() {
        return [];
    }

    getByEvent(eventId) {
        return this.getState().filter((elem) => (!!elem && elem.eventId === eventId));
    }

    reduce(state, action) {
        let data;
        switch (action.type) {

            case ActionTypes.EVENT_NOTIFICATION_LIST_SUCCESS:
                data = this.getState().filter((elem) => (!!elem && elem.eventId !== action.payload.eventId));
                return [
                    ...data,
                    ...action.data.map(sanitise)
                ];

            default:
                return state;
        }
    }
}

export default new EventNotificationStore(CentricDispatcher);
